import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from 'react-tooltip';
import { getStatus } from "../../services/Helper";

const InquiryTable = ({ inquiries }) => {

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', options).replace(',', ' at');
  };

  return (
    <>
    <div className="table-responsive">
      <table className="table table-hover align-middle table-nowrap mb-0 table-borderless" style={{ minWidth: '1000px' }}>
        <thead className="table-light">
          <tr>
            <th className="align-middle w-20" scope="col">
              #ID
            </th>
            <th className="align-middle w-20" scope="col">
              Buyer
            </th>
            <th className="align-middle" scope="col">
             Amount
            </th>
            <th className="align-middle w-20" scope="col">
             Respond Date
            </th>
            <th className="align-middle" scope="col">
              Status
            </th>
            <th className="align-middle" scope="col">
              Internal Close
            </th>
            <th className="align-middle text-center" scope="col">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {inquiries && inquiries.map((item, index) => (
            <tr key={index}>
              <td>
                <Link to={`/cases/${item._id}`}>{item.inquiryId}</Link>
              </td>
              <td className="text-body-emphasis">
                {item.buyer}{" "}
              </td>
              <td>£{item.claimAmount}</td>
                <td>{formatDate(item.respondByDate)}</td>
              <td>
                <span style={{fontSize:'10px'}}>{item.status}</span>
              </td>
              <td>
                {item.isClosed ? (
                  <span style={{fontSize:'10px'}}>TRUE</span>
                ) : (
                  <span style={{fontSize:'10px'}}>FALSE</span>
                )}
              </td>
              <td className="text-center">
                  <div className="d-flex flex-nowrap justify-content-center">
                    <Link
                      to={`/cases/${item._id}`}
                      className="btn btn-primary py-4 fs-13px btn-xs me-4"
                    >
                      <i className="fa fa-info"></i>
                    </Link>
                  </div>
                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    </>
  );
};

export default InquiryTable;
